import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import Menu from "../../json/menu_panel.json";
import AdminNavbar from './NavbarPanel';
import IconRenderer from './IconRenderer';
import { isAuth, removeLocalStorage } from '../../helper/auth';

const Sidebar = () => {
    const paths = useLocation().pathname;
    const user = isAuth();
    const [showSidebar, setShowSidebar] = useState('-left-64');
    const url = paths;

    const logout = async () => {
        await removeLocalStorage();
        window.location.href = '/login';
    };

    return (
        <>
            <AdminNavbar
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
            />
            <div onMouseLeave={() => setShowSidebar('-left-64')} className='z-10'>
                <div className={`h-screen bg-zafu-green fixed top-0 md:left-0 ${showSidebar} overflow-y-auto flex-row flex-nowrap overflow-hidden shadow-zafu-lg w-64 z-10 py-5 px-3 transition-all duration-300`}>
                    <div className="flex flex-col min-h-full relative">
                        <div className="flex items-center gap-3 px-2 mb-6">
                            <div className="w-10 h-10 rounded-full bg-zafu-cream text-zafu-green font-display font-bold text-lg flex items-center justify-center shrink-0">
                                Z
                            </div>
                            <div className="text-left leading-tight">
                                <div className="text-white font-semibold text-sm tracking-wide">ZAFU RESIDENCE</div>
                                <div className="text-white/60 text-xs">Staff Panel</div>
                            </div>
                        </div>

                        <ul className="flex flex-col gap-1 list-none flex-1">
                            {Menu.map((item, index) => {
                                const active = url === item.link || url.startsWith(item.link);
                                return (
                                    <NavLink
                                        key={index}
                                        to={item.link}
                                        className={active ? "zafu-sidebar-link-active" : "zafu-sidebar-link"}
                                    >
                                        <li
                                            onClick={() => setTimeout(() => setShowSidebar('-left-64'), 500)}
                                            className="flex items-center gap-3 w-full"
                                        >
                                            <span className="text-lg leading-none">
                                                <IconRenderer iconStr={item.icon} />
                                            </span>
                                            {item.name}
                                        </li>
                                    </NavLink>
                                );
                            })}
                        </ul>

                        <div className="mt-auto pt-4 border-t border-white/10">
                            <div className="flex items-center gap-3 px-2 mb-3">
                                <div className="w-9 h-9 rounded-full bg-white/15 text-white text-sm font-semibold flex items-center justify-center">
                                    {(user?.nama || 'S').charAt(0).toUpperCase()}
                                </div>
                                <div className="min-w-0">
                                    <div className="text-white text-sm font-medium truncate">{user?.nama || 'Staff'}</div>
                                    <div className="text-white/50 text-xs truncate">@{user?.username || 'staff'}</div>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={logout}
                                className="zafu-sidebar-link w-full text-left flex items-center gap-3"
                            >
                                <FaSignOutAlt className="text-lg text-white/90 shrink-0" />
                                Log Out
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sidebar
